module.exports = __webpack_public_path__ + "img/woman-handshake2.dad65611.jpg";